module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie DimensionsInput is an input for entering image dimensions ( width ✕ height). The Nessie DimensionsInput consists of two TextInputs separated by an _✕_.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;DimensionsInput widthPlaceholder  = &quot;width&quot;\n                 heightPlaceholder = &quot;height&quot;/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/DimensionsInput/README.md
// module id = 344
// module chunks = 0